<script>
import { getChartDataForFinancialPeriod } from '../../api'
// Components
import { baseDonutCmp } from '../baseDonutCmp'

export default {
  provide: {
    chartName: 'share-per-subject-category'
  },

  ...baseDonutCmp(getChartDataForFinancialPeriod)
}
</script>
